<template>
  <div class="exhibitionPage">
    <div class="exhibition-content">
      <div
        v-for="item in pageList"
        :key="item.id"
        class="show-box"
        @click="toExhibitInfo(item)"
      >
        <img class="exhibitShowImg" :src="item.showImg" alt="" />
        <img
          class="exhibit-arrow-hover"
          v-if="isIndex"
          src="@/assets/rightArr_black.png"
          alt=""
        />

        <div class="exhibit-title" v-if="!isIndex">
          {{ lan ? item.exhibitEnTitle : item.exhibitCnTitle }}
        </div>
        <div class="exhibit-sub-title" :class="{ 'empty-content': !(lan ? item.exhibitEnSubTitle : item.exhibitCnSubTitle) }">
          {{ lan ? item.exhibitEnSubTitle : item.exhibitCnSubTitle }}
        </div>
        <div class="exhibit-dec" v-if="!isIndex">
          {{ lan ? item.exhibitPlaceEn : item.exhibitPlaceCn }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ExhibitionPage",
  components: {
    // Menu
  },
  data() {
    return {
      isIndex: false,
      pageList: [],
      currentIndex: 0,
      pageIndex: 1,
      pageSize: 6,
      total: 0,
      maxPageIndex: 1,
      lan: this.$store.state.isEn,
      isBackNavigation: false,
      pendingScrollPosition: null, // 存储待恢复的滚动位置
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  created() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  // 使用 activated 钩子，适用于 keep-alive 组件
  activated() {
    // 只有在非返回操作时才恢复滚动位置
    if (!this.isBackNavigation) {
      this.restoreScrollPosition();
    } else {
      // 如果是返回操作，设置标记并在下一次 DOM 更新后恢复滚动
      this.isBackNavigation = false;
      this.$nextTick(() => {
        this.restoreScrollPosition();
      });
    }
  },
  mounted() {
    // 页面加载完成后恢复滚动位置
    // 只有在非返回操作时才恢复滚动位置
    if (!this.isBackNavigation) {
      this.restoreScrollPosition();
    } else {
      // 如果是返回操作，设置标记并在下一次 DOM 更新后恢复滚动
      this.isBackNavigation = false;
      this.$nextTick(() => {
        this.restoreScrollPosition();
      });
    }

    // 监听页面可见性变化
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    // 监听浏览器前进后退按钮
    window.addEventListener("popstate", this.handlePopState);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("popstate", this.handlePopState);
  },
  methods: {
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
      }
    },
    init() {
      this.$api.get(
        "/exhIbit/list",
        { current: 1, pageSize: 10, showFlag: 0, exhibitPlaceType: 1 },
        (r) => {
          const { data, code } = r;
          if (code == 0) {
            this.pageList = data;
            // 数据加载完成后，如果有待恢复的滚动位置，则执行恢复
            if (this.pendingScrollPosition) {
              this.$nextTick(() => {
                this.executeScroll(this.pendingScrollPosition);
                this.pendingScrollPosition = null;
              });
            }
          }
        }
      );
    },
    // 保存滚动位置
    saveScrollPosition() {
      // 保存当前页面的滚动位置
      const scrollPosition = {
        x: window.pageXOffset || document.documentElement.scrollLeft,
        y: window.pageYOffset || document.documentElement.scrollTop,
      };

      // 将滚动位置保存到 sessionStorage 中，使用当前路由作为 key
      const key = `scrollPosition_${this.$route.fullPath}`;
      sessionStorage.setItem(key, JSON.stringify(scrollPosition));
    },

    // 恢复滚动位置
    restoreScrollPosition() {
      // 使用当前路由作为 key 从 sessionStorage 中获取保存的滚动位置
      const key = `scrollPosition_${this.$route.fullPath}`;
      const savedPosition = sessionStorage.getItem(key);

      if (savedPosition) {
        try {
          const position = JSON.parse(savedPosition);
          // 检查数据是否已经加载完成
          if (this.pageList && this.pageList.length > 0) {
            // 如果数据已加载，直接执行滚动
            this.executeScroll(position);
          } else {
            // 如果数据未加载，先保存位置，等数据加载完成后再执行
            this.pendingScrollPosition = position;
          }
        } catch (e) {
          console.error("恢复滚动位置失败:", e);
        }
      }
    },

    // 执行滚动操作
    executeScroll(position) {
      this.$nextTick(() => {
        // 添加额外的延迟确保页面完全渲染
        setTimeout(() => {
          window.scrollTo({
            top: position.y,
            left: position.x,
            behavior: "auto",
          });
        }, 100);
      });
    },

    // 处理页面可见性变化
    handleVisibilityChange() {
      if (!document.hidden) {
        // 页面变为可见时恢复滚动位置
        this.restoreScrollPosition();
      }
    },

    // 处理浏览器前进后退按钮
    handlePopState(event) {
      this.isBackNavigation = true;
      // 在下一个事件循环中恢复滚动位置
      this.$nextTick(() => {
        setTimeout(() => {
          this.restoreScrollPosition();
        }, 100);
      });
    },

    toExhibitInfo(e) {
      // 标记这不是返回操作
      this.isBackNavigation = false;

      // 在跳转前保存当前滚动位置
      this.saveScrollPosition();

      this.$router.push({
        path: "/exhibition/exhibitionInfo",
        query: {
          columnId: 23,
          id: e.id,
        },
      });
    },
  },
};
</script>
<style scoped>
.exhibitionPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.exhibition-content {
  width: 1440px;
  margin: 134px auto 60px;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
}
.show-box {
  width: 450px;
  min-height: 750px;
  margin: 30px 30px 20px 0;
  cursor: pointer;
}
.show-box img {
  width: 450px;
  height: 634px;
  object-fit: contain;
}

.exhibit-title {
  margin-top: 15px;
  font-family: SourceHanSansCN-Bold;
  font-size: 38px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.exhibit-sub-title {
  margin-top: 8px;
  font-family: SourceHanSansCN-Regular;
  font-size: 22px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
  min-height: 30px; /* 新增：确保无内容时仍占位 */
}
.exhibit-dec {
  margin-top: 8px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
}
@media (max-width: 1440px) {
  .currentExhibition {
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
  .exhibition-content {
    width: 98%;
    transform: scale(0.9);
    margin: 60px auto 30px;
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
  }
  .exhibit-title {
    margin-top: 15px;
    font-family: SourceHanSansCN-Bold;
    font-size: 38px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .exhibit-sub-title {
    margin-top: 8px;
    font-family: SourceHanSansCN-Regular;
    font-size: 22px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 400;
    min-height: 30px; /* 新增：移动端也保持最小高度 */
  }
  .exhibit-dec {
    margin-top: 8px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    font-weight: 400;
  }
  .exhibition-content .show-box {
    width: 425px;
    min-height: 650px;
    margin: 30px 20px 20px 0;
    cursor: pointer;
  }
  .show-box img {
    width: 425px;
    height: auto;
    max-height: 604px;
    object-fit: contain;
  }

  .show-box .exhibit-arrow-hover {
    width: 48px;
    height: 30px;
    position: absolute;
    top: 30px;
    right: 30px;
  }
}
@media (max-width: 960px) {
  .currentExhibition {
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
  .exhibition-content {
    width: 89%;
    margin: 100px auto 30px;
    background-color: #fff;
    display: flex;
    transform: scale(1);
    flex-wrap: wrap;
  }
  .exhibition-content .show-box {
    position: relative;
    width: 100%;
    height: auto;
    min-height: 400px;
    margin: 10px auto 0;
    cursor: pointer;
  }
  .exhibition-content .show-box .exhibitShowImg {
    position: relative;
    width: 100%;
    height: auto;
    max-height: 100%;
    object-fit: cover;
  }

  .exhibit-title {
    margin-top: 15px;
    font-family: SourceHanSansCN-Bold;
    font-size: 38px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .exhibit-sub-title {
    margin-top: 8px;
    font-family: SourceHanSansCN-Regular;
    font-size: 22px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 400;
    min-height: 30px; /* 新增：移动端保持最小高度 */
  }
  .exhibit-dec {
    margin-top: 8px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    font-weight: 400;
  }
  .exhibition-content .show-box .exhibit-arrow-hover {
    width: 30px;
    height: 18px;
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
@media (max-width: 768px) {
}
@media (max-width: 640px) {
}
</style>